module.exports = __webpack_public_path__ + "static/logo-e5565da74434560691def7a6ac166d96.jpg";